// extracted by mini-css-extract-plugin
export default {"ribbons":"ribbon-module__ribbons__L5iGp","templateTwoRibbon":"ribbon-module__templateTwoRibbon__R1wLZ"};